import styled from 'styled-components'

import {inheritRowStyles} from "#app/components/UI/styles";

export const Container = styled.div`
  &#calendar-config {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
`;

export const FunnelFinanceGroupSelectorContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  font-size: 14px;
`;

export const FunnelFinanceGroupSelector = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  background-color: #333443;
  padding: 3px;
  gap: 5px;
  border-radius: 11px;

  button {
    outline: none;
    border: 1px solid #454650;
    background: transparent;
    color: white;
    padding: 10px;
    cursor: pointer;
    border-radius: 8px;
  }

  button.selected {
    background: #3C6CE6;
  }
`;

export const FunnelTableContainer = styled.div`
  .table-row__styled {
    height: 30px;
  }
`;

export const FunnelClientTablesWrapper = styled.div.attrs({className: `styled__user-tables`})`
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(2, 1fr);
  min-height: 320px;
  margin: 20px;
  min-width: 0;

  & > * {
    min-width: 0;
  }
  
  @media screen and (max-width: 1600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const FullWidthContainer = styled.div`
  position: relative;
  width: 100%;
  min-width: 100%;
  margin: 0 25px;
  display: flex;
  flex-wrap: wrap;

  span{
    display: inline-block;
  }

  span.green{
    color: #66C838!important;
  }
  
  span.red{
    color: #EF5E70!important;
  }
`

export const Wrapper = styled.div`
    color: #fff;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 5px 20px 20px 20px;
    overflow: visible;
    min-height: 700px;
    border-radius: 16px;
    margin-bottom: 30px;
    
    .sticky {
      position: fixed;
      top: 0;
      width: 100%;
    }
    
    .sticky + .content {
      padding-top: 102px;
    }
`

export const CenteredWrapper = styled.div`
    background-color: #262732;
    color: #fff;
    flex-grow: 1;
    flex-shrink: 1;
    padding: 5px 20px 25px 20px;
    overflow: visible;
    min-height: 600px;
`

export const Title = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  margin: 15px 0;
  
  ${props => props.flex && `
    flex: 1;
  `}
`
export const SmallTitle = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  margin: 15px 0;
  
  ${props => props.flex && `
    flex: 1;
  `}
`
export const FullWidthTitle = styled.h1`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  margin: 15px 0;
  width: 100%;
`
export const InvestTitle = styled.h1`
  display: flex;
  margin: 10px 0; 
  width: 100%;

  div:nth-child(1)
  {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    flex: 1;
    text-align: left;
  }
  
  div:nth-child(2)
  {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    flex: 1;
    text-align: right;
  }
`
export const InvestTitleHover = styled.h1`
  display: flex;
  margin: 10px 0; 
  width: 100%;
  cursor: pointer;

  div:nth-child(1)
  {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    flex: 1;
    text-align: left;
  }
  
  div:nth-child(2)
  {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 14px;
    flex: 1;
    text-align: right;
  }
  
  :hover{
    background-color: #F5F5F5;
  }
`

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;

  &.source__creation-form-row .styled-input__pseudo-input.input > span,
  &.source__creation-form-row .styled-input__results-list.item > span {
    gap: .5em !important;
  }
  
  &.source__refuse-reason-row .styled-input__pseudo-input.input {
    border-radius: 0;
  }
  
  .source__application-status-select {
    border-radius: 0;
  }
  
  ${inheritRowStyles}
  
  .aton__select-flex {
    flex-basis: 30%;
  }
  
  @media screen and (max-width: 1660px) {
    .aton__select-flex {
      flex-basis: 40%;
    }
  }
  
  @media screen and (max-width: 1280px) {
    .aton__select-flex {
      flex-basis: 65%;
    }
  }
    
  ${props => props.flex && `
    flex: 1;
  `}
  
  ${props => props.flexWidth && `
      flex-basis: ${props.flexWidth};
  `}
  
  ${props => props.right && `
    justify-content: end;
  `}
`

export const EventTaskCardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 24px;
`;

export const EventTaskCommentInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 4px;
  
  .event_comment {
    font-size: 16px;
    color: white;
    word-break: break-word;
  }
`;

export const EventTaskTextInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 16px;
  width: 100%;
  
  .event__row {
    gap: 24px;
    color: white;
    font-size: 16px;
  }
  
  .event__row.justify__space-between {
    justify-content: space-between;
  }

  .event__calendar,
  .event__repeat,
  .event__subject,
  .event__type {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: start;
    align-items: center;
    
    .invalid-date__placeholder {
      color: #EF5E70;
    }
    
    svg {
      width: 16px;
      height: 16px;
    }
  }
  
`;

export const EventTaskButtonRow = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  align-items: center;
  gap: 24px;
  
  button {
    width: fit-content;
    padding: 6px 24px !important;
    min-width: 50%;

  }
  
  button:first-of-type {
    align-self: end;
    justify-self: end;
  }
  
  button:last-of-type {
    align-self: start;
    justify-self: start;
  }
`;

export const EventTaskButtonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  width: 100%;

  button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 11px 48px !important;
    height: unset !important;
  }
  
  button svg {
    margin: 0 !important;
    width: 24px !important;
    height: 24px !important;
    object-fit: cover;
  }
`;

export const TopRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  margin: 13px 10px 10px 0;
  flex: 1;
`

export const ButtonRow = styled.div`
  text-align: left;
  flex: 1;
  
  ${props => props.align === 'right' && `
    text-align: right;
  `}
  ${props => props.align === 'center' && `
    text-align: center;
  `}
  ${props => props.flex && `
      display: flex;
      flex-basis: 100%;
  `}
  ${props => props.justify && `
      justify-content: space-between;
  `}
`

export const Checkboxes = styled.div`
    margin-bottom: 5px;
`

export const CheckSection = styled.div`
    margin: 0 10px;
    padding-top: 30px;
    padding-bottom: 30px;
    background-color:rgb(249, 249, 249);
    text-align:left;
`

export const CheckboxContainer = styled.div`
  display: flex;
  padding: 14px;
  flex-wrap: wrap;
`


export const Column = styled.div`
  flex: 1;
`

export const Chart = styled.div`
  display: inline-block;
`
